/*
 * Page Name
 */

jQuery(document).ready(function () {
    _heightline({
        itemClsName: '.inside_block04_box ._year',
        itemPerRow: 3,
        device: 'pc'
    });
    _heightline({
        itemClsName: '.inside_block04_box ._item ._img01',
        itemPerRow: 3,
        device: 'pc'
    });
});